import actionNames from './actionNames'

const mutations = {
  publisher(state, publisher) {
    state.publisher = publisher
  },
  subId(state, subId) {
    state.subId = subId
  },
  team(state, team) {
    state.team = team
  },

  isLineItemHistoryModalVisible(state, isLineItemHistoryModalVisible) {
    state.isLineItemHistoryModalVisible = isLineItemHistoryModalVisible
  },
  [actionNames.GET_10_DAY_HISTORY_REQUESTED](state) {
    state.isLoadingLineItemHistory = true
    state.didLoadLineItemHistoryFail = false
  },
  [actionNames.GET_10_DAY_HISTORY_SUCCEEDED](state, items) {
    state.lineItemHistory = Object.freeze(items)
    state.isLoadingLineItemHistory = false
  },
  [actionNames.GET_10_DAY_HISTORY_FAILED](state) {
    state.isLoadingLineItemHistory = false
    state.didLoadLineItemHistoryFail = true
  },

  [actionNames.GET_CREATIVES_REPORT_REQUESTED](state) {
    state.isLoadingCreativesReport = true
    state.didLoadCreativesReportFail = false
  },
  [actionNames.GET_CREATIVES_REPORT_SUCCEEDED](state, items) {
    state.creativesReport = Object.freeze(items)
    state.isLoadingCreativesReport = false
  },
  [actionNames.GET_CREATIVES_REPORT_FAILED](state) {
    state.isLoadingCreativesReport = false
    state.didLoadCreativesReportFail = true
  },

  [actionNames.GET_CREATIVE_REQUESTED](state) {
    state.isLoadingLineItemCreative = true
    state.didLoadLineItemCreativeFail = false
  },
  [actionNames.GET_CREATIVE_SUCCEEDED](state, data) {
    state.creatives = Object.freeze(data)
    state.isLoadingLineItemCreative = false
  },
  [actionNames.GET_CREATIVE_FAILED](state) {
    state.isLoadingLineItemCreative = false
    state.didLoadLineItemCreativeFail = true
  },

  [actionNames.GET_TEARSHEET_REQUESTED](state) {
    state.isLoadingLineItemTearsheet = true
    state.didLoadLineItemTearsheetFail = false
  },
  [actionNames.GET_TEARSHEET_SUCCEEDED](state, data) {
    const { creativeId, tearsheetUrl } = data

    state.tearsheets = { ...state.tearsheets, [creativeId]: { tearsheetUrl } }
    state.isLoadingLineItemTearsheet = false
  },
  [actionNames.GET_TEARSHEET_FAILED](state, data) {
    state.isLoadingLineItemTearsheet = false
    state.didLoadLineItemTearsheetFail = true

    const { error, id } = data
    const tearsheets = {
      ...state.tearsheets,
      [id]: {
        error,
        tearsheetUrl: null,
      },
    }

    state.tearsheets = tearsheets
  },

  [actionNames.GET_DISCREPANCY_CREATIVES_REQUESTED](state) {
    state.isLoadingDiscrepancyCreatives = true
    state.didLoadDiscrepancyCreativesFail = false
  },
  [actionNames.GET_DISCREPANCY_CREATIVES_SUCCEEDED](state, items) {
    state.discrepancyCreatives = Object.freeze(items)
    state.isLoadingDiscrepancyCreatives = false
  },
  [actionNames.GET_DISCREPANCY_CREATIVES_FAILED](state) {
    state.isLoadingDiscrepancyCreatives = false
    state.didLoadDiscrepancyCreativesFail = true
  },

  columns(state, columns) {
    state.columns = { ...state.columns, ...columns }
  },
  currentRecord(state, currentRecord) {
    state.currentRecord = currentRecord
  },
  isCreativeModalVisible(state, isVisible) {
    state.isCreativeModalVisible = isVisible
  },
  isCreativesReportModalVisible(state, isVisible) {
    state.isCreativesReportModalVisible = isVisible
  },
  isDiscrepancyCreativeModalVisible(state, isVisible) {
    state.isDiscrepancyCreativeModalVisible = isVisible
  },
  isLegendModalVisible(state, isVisible) {
    state.isLegendModalVisible = isVisible
  },
}

export default mutations
